<a [id]="'section_' + section.id" class="section-anchor-link"></a>
<div class="ignore-elements list-section-top-holder" [ngClass]="{'list-section-close' : !isOpen}" rlStopPropagation>
    <div class="list-section-header justify-content" *ngIf="!editMode">
        <div class="flex-start">
            <!-- <div *ngIf="!isOpen" class="section-thumbs">
                <rl-thumbnail *ngFor="let t of section.thumbnails" [thumbnail]="t"></rl-thumbnail>
            </div> -->
            <h2 class="list-section-title" [ngClass]="{'list-section-title-close' : !isOpen, 'list-section-title-open' : isOpen}">
            <!-- trigger thubmnails for sections -->
            <!-- <span *ngIf="isOpen" list="item" section="section" lazy-load></span> -->
                <span class="name" (click)="toggleOpenClose()" attr.aria-expanded="{{!isOpen}}">
                    {{section.name}}
                    <span class="section-title-data">
                        <span class="small-text text-muted">
                            (<span *ngIf="displayPageCount && section.totalPages > 0">{{'lists.action.exportToCitations' | translate}}:
                            </span>{{section.collectionSize}}
                            <!-- count by filter included {{section | citationCount}} -->
                            <span *ngIf="displayPageCount && section.totalPages > 0">, {{'list.countPages' | translate}}: {{countPages(section)}}</span>)
                        </span>
                        <i class="fa fa-angle-right" attr.aria-hidden="true" title="{{'lists.field.tooltip.toggle_section' | translate}}"></i>
                    </span>
                </span>
            </h2>
        </div>
        <div class="flex-end">
            <rl-date-range *ngIf="section.start || section.end" class="inline-block" [start]="section.start" [end]="section.end" [showOnlyInRange]="section.publishSectionVisible"></rl-date-range>
            <rl-menu class="btn-group ignore-elements" [actions]="menuOptions" (onClick)="this[$event]()"></rl-menu>
        </div>
    </div>
    <!-- import to section form -->
    <div class="import-in-section" *ngIf="editMode">
        <!-- Edit section -->
        <rl-edit-form [formType]="'SECTION'" [type]="'edit'" [item]="section" (onClose)="editMode=false" (onCancel)="editMode=false"></rl-edit-form>
    </div>
    <div class="section-added-content" [ngClass]="{'list-section-closed' : isOpen}" rlStopPropagation>
        <!-- scroll fix -->
        <div rlStopPropagation>
            <div class="pull-left"></div>
            <div class="ClearBoth"></div>
        </div>
        <!-- section description -->
        <div class="list-section-description multiline" *ngIf="section.description && !editMode && !section.showImport"> {{section.description}} </div>
        <!-- tags section -->
        <!-- <rl-tags list="item" item="section" hierarchy="item.hierarchy" level="SECTION" class="section-tags" *ngIf="!isInlineEdit(section.id) && !section.showImport"></rl-tags> -->
        <!-- Section lock -->
        <!-- <rl-list-lock item="section" type="'SECTION'"></rl-list-lock> -->
    </div>
</div>                                                                                                                          <!-- <span *ngIf="!isOpen" id="section-open-{{$index}}" class="display-none"></span> -->
<div class="list-section-content-holder" *ngIf="isOpen" [ngClass]="{'section-second-level' : section.indentation == 1, 'section-third-level' :  section.indentation == 2,'section-forth-level' : section.indentation == 3}">
    <ng-content></ng-content>
</div>